import { useState } from "react";
import axios from "axios";
import { Download, Camera } from "lucide-react";
import { ScaledStill } from "./shared";
import { STILLS } from "@/stills";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function StillCard({ still, onRendered, spaStyle }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const def = STILLS[still.id];

  const render = async () => {
    setBusy(true); setErr(null);
    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/render/${still.id}`);
      onRendered(still.id, data.url);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Render failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="card fade-up" data-testid={`still-card-${still.id}`} style={{ padding: 20, width: 320 }}>
      <ScaledStill Component={def.Component} w={def.w} h={def.h} width={280} spaStyle={spaStyle} />
      <div style={{ marginTop: 16, fontSize: 13, fontWeight: 600, lineHeight: 1.3 }}>{still.title}</div>
      <div style={{ fontSize: 11, color: "var(--ink-40)", marginTop: 4 }}>{still.width}×{still.height} · {still.device}</div>
      {err && <div data-testid={`still-error-${still.id}`} style={{ fontSize: 11, color: "var(--burgundy)", marginTop: 6 }}>{err}</div>}
      <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
        <button className={`btn ${still.url ? "btn-ghost" : "btn-primary"}`} data-testid={`render-${still.id}`} disabled={busy} onClick={render}>
          <Camera size={14} />{busy ? "Rendering…" : still.url ? "Re-render" : "Render PNG"}
        </button>
        {still.url && (
          <a className="btn btn-ghost" data-testid={`download-${still.id}`} href={`${BACKEND_URL}${still.url}?t=${still.created_at}`} download={`${still.id}.png`} target="_blank" rel="noreferrer">
            <Download size={14} />PNG
          </a>
        )}
      </div>
    </div>
  );
}
